import { BroadcastStatus } from '../types/broadcast';

export const BROADCAST_STATUSES_ABLE_TO_END = new Set([
    BroadcastStatus.STARTING,
    BroadcastStatus.STARTED,
    // Пауза
    BroadcastStatus.FINISHED,
]);
